import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { closeCollapsible, downloadFile, getCompanyInfo, isNullOrEmpty, leftPad, showMessageToast, translate } from '../../../../utils/util';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { Title, Subtitle, BackButton, Input, Card, Button, InfiniteScroll, Collapsible, SelectResource, Modal, Fab } from '../../../../components/UI/ComponentsUI';
import LinePickingService from '../../../../services/LinePickingService';
import * as actionLinePicking from '../../../../actions/linePickingAction';
import M from 'materialize-css/dist/js/materialize';
import ConfirmModal from '../../../../components/UI/ConfirmModal';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import Select from '../../../../components/UI/Select';
import StockService from '../../../../services/StockService';
import { ENUMS } from '../../../../utils/constants';
import { getVision } from '../../../../../src/services/auth';
import { VISIONS, PLANTS } from '../../../../utils/constants';
import PhysicalConfirmationService from '../../../../services/PhysicalConfirmationService';
import RoutePickingService from '../../../../services/RoutePickingService';
import InputUI from '../../../../components/UI/InputUI';
import ModalUploadQuantityMassive from './ModalUploadQuantityMassive';

const MappingList = (props) => {
    const quantityAlignment = props.location?.state?.quantityAlignment;
    const [mappings, setMappings] = useState([]);
    const [mappingsRegistration, setMappingsRegistration] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [refresh, setRefresh] = useState(0);
    const [filter, setFilter] = useState({ class: [], route: [], line: [] });
    const [selectedItems, setSelectedItems] = useState([]);
    const [openModal, setOpenModal] = useState({ open: false, mappingIds: undefined });
    const [openQuantityAlignmentModal, setOpenQuantityAlignmentModal] = useState({ open: false, mappingId: undefined, quantityLine: undefined, minLimit: undefined });
    const [itemDelete, setItemDelete] = useState(null);
    const [arrayDrop, setArrayDrop] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [quantityAlignmentModel, setquantityAlignmentModel] = useState({});
    const [openModalUpload, setOpenModalUpload] = useState(false);

    useEffect(() => {
        if (props.mappings?.items?.length > 0) {
            if (mappings.length > 0 && currentPage === 0) {
                setMappings([...props.mappings.items]);
            } else {
                setMappings((prevState) => ([...prevState, ...props.mappings.items]));
            }
        } else {
            setMappings([]);
        }
        // eslint-disable-next-line
    }, [props?.mappings?.items]);

    const getMappings = () => {
        if (validateInputsRequired("formfilter")) {
            let filterSearch = {
                PageSize: 20,
                PageIndex: currentPage,
                ...filter
            }

            props.getMappingPaged(filterSearch, true, () => {
                closeCollapsible("collapsible2")
            });
        }
    }

    useEffect(() => {
        props.getRoutes({ routeType: ENUMS.eRouteType.LinePicking.value }, (data) => {
            var drop = data.map((i) => {
                return { id: i.value, text: i.value };
            }).sort((a, b) => {
                if (a.text < b.text) { return -1; }
                if (a.text > b.text) { return 1; }
                return 0;
            });
            setArrayDrop(drop);
        });
        props.getMappingRegistrationAll({}, (data) => {
            setMappingsRegistration([...data]);
        });

        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        getMappings();
        // eslint-disable-next-line
    }, [currentPage, refresh]);


    const onFilter = () => {
        setSelectedItems([]);
        setCurrentPage(0);
        setRefresh(refresh + 1);
        window.scrollTo(0, 0);
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onChangeQuantityAligment = (event) => {
        onValueChange(event, quantityAlignmentModel, setquantityAlignmentModel);
    };

    const onSelectItemChange = (data) => {
        props.setMapping(data);
        props.history.push({
            pathname: '../mapping/insert',
            state: { update: true }
        });
    };

    const onDelete = (data) => {
        setItemDelete(data)
        const modal = M.Modal.init(document.getElementById('confirmDelete'));
        modal.open();
    };

    const onConfirmDelete = () => {
        props.deleteMapping(itemDelete.id, () => {
            onFilter();
            setItemDelete(null);
        });
    }

    const onCheckItem = (item) => {
        let arr = [];
        Object.assign(arr, selectedItems);
        let index = selectedItems.findIndex((e) => e === item.id);
        if (index === -1) {
            arr.push(item.id)
        } else {
            arr.splice(index, 1);
        }
        setSelectedItems(arr)
    }

    const deleteSelectedItems = () => {
        const modal = M.Modal.init(document.getElementById('confirmDeleteSelected'));
        modal.open();
    }

    const onConfirmDeleteSelected = () => {
        props.deleteSelected(selectedItems, () => {
            onFilter()
        })
    }

    const downloadFileMapping = (ids) => {
        setOpenModal({ open: false, mappingIds: undefined });
        props.downloadFileMapping(ids, (response) => {
            downloadFile(response, `Mapatura.pdf`, "data:application/pdf", true)
        })
    }

    //INDEX LIST
    // 1 - DesignPDURegistration
    // 2 - PDURegistration
    // 3 - DesignWorkLocal
    // 4 - InsertMonth
    const getDataToExport = (index) => {
        if (selectedItems && selectedItems.length > 0) {
            var data = mappings.filter(f => selectedItems.includes(f.id));
            ExportReport(index, data);
        }
        else {
            props.getMappingPaged({
                ...filter
            }, true, (resp) => {
                ExportReport(index, resp.items);
            });
        }
    }

    const ExportReport = (index, data) => {
        switch (index) {
            case 1:
                return exportExcelDesignPDURegistration(data);
            case 2:
                return exportExcelPDURegistration(data);
            case 3:
                return ExportDesignWorkLocal(data);
            case 4:
                return ExportInsertMonth(data);
            case 5:
                return ExportMapping(data);
            default:
                break;
        }
    }

    const ExportInsertMonth = (data) => {

        // Busca de Informação de Almoxarifado.
        const filter = {
            PartNumberCodes: data.map(f => f.partNumber),
            companyId: getVision().split('-')[0],
            warehouseId: getVision().split('-')[1]
        };

        props.getLastReceiptStorageByPartnumbers(filter, (resp) => {
            for (let i = 0; i < data.length; i += 1) {
                const almox = resp.filter(f => f.partNumberCode === data[i].partNumber)[0]?.almox
                data[i].almox = almox ?? ''
            }

            ExportInsertMonthInternal(data)
        })
    }

    const ExportInsertMonthInternal = (data) => {

        var sheet = data.map(f => ([
            "INS", // Função
            `WPA_${f.parts}${f.line}_${f.station.toString().padStart(3, '0')}_${f.side}_OT_CM`, // Workplace
            `L${leftPad(f.id + 1, 9, '0')}`,// Codice
            `${f.parts} ${f.line}`, // Descrição 
            "GEMAP", // Gestor
            "Sim", // Habilitado
            "Consegna da CARRELLO", // Modo de fechamento
            f.partNumber, // Desenho
            f.partNumberDesc, // Descrição do desenho
            f.route, // Linha/Fabricado
            f.street, // Rua Logistics
            f.station, // Estação Logistics
            f.side, // Lado Logistics
            f.space, // Quinto Nível
            f.qme, // Quantidade MDR
            "0", // Qta. Efetiva
            "Não", // Chamada Multipla
            "Soglia por Estação", // Tipo Limite (Soglia)
            parseInt((f.qme / 2)), // Limite (Soglia)
            "100", // Percentual Prelievo
            "5", // Precisão de a
            "Não", // Tipo Arredondamento
            "", // Centralina On
            "0", // Número Pulsante On
            "", // Centralina OFF
            "0", // Número Pulsante OFF
            "0", // Tempo de espera ativado (minutos)
            "0", // Tempo de espera desativado (minutos)
            "Sim", // Agendamento Habilitado
            "0", // Tipo Autonomia (minutos)
            f.route, // Rotta/Settore Deposito
            "1", // Posizione Rotta
            "", // Código Settore Prelieva
            "Quintuplo", // Tipologia de Transporte
            "", // Centralina Lampada
            "0", // Número Bit
            `ALMX_${f.almox}`, // Almoxarifado
            "", // PLC
            "", // Word/Bit
            "", // Comando
            "", // Estado
            `WPA_${f.parts}${f.line}_${f.station.toString().padStart(3, '0')}_${f.side}_OT_CM`, // UTE
            `WPA_${f.parts}${f.line}_${f.station.toString().padStart(3, '0')}`, // WIP
            "", // Código MDR
            "1", // Número da caixa
            `BSR.${f.route}`, // Área de Preparação 
            "", // Estação Master
            "120", // Limite(Soglia) Crítico 
            "1", // Posição no comboio
            `Gravitacional ${f.gravitational.toString()}`, // Tipo de vagão
            "", // Fornecedor
            "Minutos", // Tipo de Limite (soglia) Critico
            "Não", // Entrega de confirmação da solicitação
            "", // Agendamento 
            f.parts, // Filtro de Agregação
            "", // Unidade
            "", // Cod. Trato
            "", // Dominio (Time)
            "", // Estação
            "", // Posição
            "1", // Número Chamada
            "Decremento da Distinta Base", // Tipo de chamada Automática
            "Barcode/PC", // Tipo de chamada Manual
            '1', // [QtaTransito]
            "0" // [QtaBom]
        ]))

        var sheetAux = [
            [
                'Função',
                'Workplace',
                'Codice',
                'Descrição',
                'Gestor',
                'Habilitado',
                'Modo de fechamento',
                'Desenho',
                'Descrição do desenho',
                'Linha/Fabricado',
                'Rua Logistics',
                'Estação Logistics',
                'Lado Logistics',
                'Quinto Nível',
                'Quantidade MDR',
                'Qta. Efetiva',
                'Chamada Multipla',
                'Tipo Limite (Soglia)',
                'Limite (Soglia)',
                'Percentual Prelievo',
                'Precisão de a',
                'Tipo Arredondamento',
                'Centralina On',
                'Número Pulsante On',
                'Centralina OFF',
                'Número Pulsante OFF',
                'Tempo de espera ativado (minutos)',
                'Tempo de espera desativado (minutos)',
                'Agendamento Habilitado',
                'Tipo Autonomia (minutos)',
                'Rotta/Settore Deposito',
                'Posizione Rotta',
                'Código Settore Prelieva',
                'Tipologia de Transporte',
                'Centralina Lampada',
                'Número Bit',
                'Almoxarifado',
                'PLC',
                'Word/Bit',
                'Comando',
                'Estado',
                'UTE',
                'WIP',
                'Código MDR',
                'Número da caixa',
                'Área de Preparação',
                'Estação Master',
                'Limite(Soglia) Crítico',
                'Posição no comboio',
                'Tipo de vagão',
                'Fornecedor',
                'Tipo de Limite (soglia) Critico',
                'Entrega de confirmação da solicitação',
                'Agendamento',
                'Filtro de Agregação',
                'Unidade',
                'Cod. Trato',
                'Dominio (Time)',
                'Estação',
                'Posição',
                'Número Chamada',
                'Tipo de chamada Automática',
                'Tipo de chamada Manual',
                '[QtaTransito]',
                '[QtaBom]'
            ],
            ...sheet
        ];

        exportExcel(sheetAux, 'Cadastro MES.xlsx', []);
    }

    const ExportMapping = (data) => {
        var sheet = data.map(f => ([
            f.partNumber, // Desenho
            f.partNumberDesc, //Descrição do Desenho,
            f.class, //Classe
            f.line, //Linha
            f.use,        //Uso
            f.model,        //Modelo,
            f.gravitational, // Gravitacional
            f.parts, // Trecho
            f.side, //Lado
            f.route, //Rota
            f.street, //Rua
            f.station, //Estação,
            f.space, //vaga
            f.qme, //qme
            f.mdr, //mdr
            f.boxLimit, //Limite de Caixas
            f.picking, //picking
            f.alternativePartNumber, //Desenho alternativo
            f.pdu, //pdu
            `L${leftPad(f.id + 1, 9, '0')}`,// Codice

        ]));

        var sheetAux = [
            [
                'Desenho',
                'Descrição',
                'Classe',
                'Linha',
                'Uso',
                'Modelo',
                'Gravitacional',
                'Trecho',
                'Lado',
                'Rota',
                'Rua',
                'Estação',
                'Vaga',
                'Qme',
                'Mdr',
                'Limite de Caixas',
                'Picking',
                'Desenho Alternativo',
                'PDU',
                'Códice'
            ],
            ...sheet
        ];

        exportExcel(sheetAux, 'Mapping.xlsx', []);
    }

    const ExportDesignWorkLocal = (data) => {
        const companyInfo = getCompanyInfo()

        var sheet = data.map(f => ([
            companyInfo.plant, // Planta
            companyInfo.company, // Site
            "LOC", // Tipo de Site
            f.partNumber, // Desenho
            `L${leftPad(f.id + 1, 9, '0')}`,// Local de Trabalho
            f.pdu, // Ponto de Uso
            "", // Modificador\ nOperador
            "", // Data
            "", // Status
            "" // Resultado
        ]))

        var sheetAux = [
            ["Desenho - Locais de Trabalho (Importação)"],
            [], [],
            ["Planta", "Site", "Tipo de Site", "Desenho", "Local de Trabalho", "Ponto de Uso", "Modificador Operador", "Data", "Status", "Resultado"],
            ...sheet
        ];

        exportExcel(sheetAux, 'Desenho_-_Locais_de_Trabalho.xlsx', [{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }]);
    }

    const exportExcelPDURegistration = (dataUse) => {
        var sheet = dataUse.map(f => ([
            f.route, //Rota do cadastro
            f.street, // Rua do cadastro
            f.station, // Estação do Cadastro
            ([f.line, f.gravitational, f.space]).join('.'), // Junção dos campos LINHA / Gravitacional / Vaga, separados por ponto
            f.side,// Lado do cadastro
            "" // Campo Vazio
        ]))

        var sheetAux = [
            ["Carregar pontos de uso"],
            [],
            [],
            ["Edifício", "Pista", "Tipo/Estação", "Posição", "Lado", "5ª Coordenada"],
            ...sheet
        ];

        exportExcel(sheetAux, 'Carregar_pontos_de_uso.xlsx', [{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }]);
    }

    const exportExcelDesignPDURegistration = (dataUse) => {
        var sheet = dataUse.map(f => ([
            f.pdu, // Informação gerado do PDU no cadastro
            f.partNumber, // Desenho do cadastro
            f.boxLimit // Campo Limite Caixas do cadastro
        ]))

        var sheetAux = [
            ["Novo Ponto de Uso XLS"],
            [],
            [],
            ["Ponto de Uso", "Desenho", "Qtd Container Padrao"],
            ...sheet
        ];

        exportExcel(sheetAux, 'Novo_Ponto_de_Uso_XLS.xlsx', [{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }]);
    }

    const exportExcel = (sheet, excelName, collumnsToMerge) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.shee;charset=UTF-8';
        const ws = XLSX.utils.aoa_to_sheet(sheet);

        if (collumnsToMerge.length > 0) {
            ws["!merges"] = collumnsToMerge
        }

        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, excelName);
    }

    const addClassAll = (item) => {
        if (item) {
            filter.class.push(item)
            setFilter(filter);
        }
    };

    const addClassFilter = (item) => {
        const selectedOptions = item.currentTarget.selectedOptions;
        filter.class = selectedOptions.length > 0 ? Array.from(selectedOptions).map(x => x.value) : []
        setFilter(filter);
    };


    const addLineAll = (item) => {
        if (item) {
            filter.line.push(item)
            setFilter(filter);
        }
    };

    const addLineFilter = (item) => {
        const selectedOptions = item.currentTarget.selectedOptions;
        filter.line = selectedOptions.length > 0 ? Array.from(selectedOptions).map(x => x.value) : []
        setFilter(filter);
    };


    const addSideAll = (item) => {
        if (item) {
            filter.line.push(item)
            setFilter(filter);
        }
    };

    const addSideFilter = (item) => {
        const selectedOptions = item.currentTarget.selectedOptions;
        filter.side = selectedOptions.length > 0 ? Array.from(selectedOptions).map(x => x.value) : []
        setFilter(filter);
    };

    const addRouteAll = (item) => {
        if (item) {
            filter.route.push(item)
            setFilter(filter);
        }
    };

    const addRouteFilter = (item) => {
        const selectedOptions = item.currentTarget.selectedOptions;
        filter.route = selectedOptions.length > 0 ? Array.from(selectedOptions).map(x => x.value) : []
        setFilter(filter);
    };


    const onClickSelectAll = () => {
        if (selectAll) {
            setSelectAll(false)
            setSelectedItems([])
        } else {
            setSelectAll(true)
            setSelectedItems(mappings.map(x => x.id))
        }
    }


    const renderItem = (data, index) => {
        return <div
            className="row"
            style={{ color: 'black', display: 'block', marginBottom: '0px', marginLeft: '0px' }}
            key={`oi-${index}`}
        >
            {!quantityAlignment &&
                <div>
                    <span
                        className="title sixth-text-color right"
                        style={{ position: 'absolute', right: '10px', cursor: 'pointer' }}
                    >
                        < i onClick={() => setOpenModal({ open: true, mappingIds: [data.id] })} className={`mdi mdi-36px mdi mdi-printer`} />
                    </span>
                    <span
                        className="title sixth-text-color right"
                        style={{ position: 'absolute', marginTop: '45px', right: '13px', cursor: 'pointer' }}
                    >
                        <i className="material-icons small sixth-text-color"
                            onClick={() => onSelectItemChange(data)}
                            style={{ cursor: 'pointer' }}>edit</i>
                    </span>
                    <span
                        className="title sixth-text-color right"
                        style={{ position: 'absolute', marginTop: '75px', right: '13px' }}
                    >
                        <i className="material-icons small sixth-text-color"
                            onClick={() => onDelete(data)}
                            style={{ cursor: 'pointer' }}>delete</i>
                    </span>
                    <span className="title sixth-text-color right"
                        style={{ position: 'absolute', marginTop: '105px', right: '3px' }}>
                        <Input
                            type="checkbox"
                            onChange={() => onCheckItem(data)}
                            id="select"
                            name="select"
                            checked={selectedItems.find(f => f === data.id) || false}
                        />
                    </span>
                </div>
            }
            {quantityAlignment &&
                <span
                    className="title sixth-text-color right"
                    style={{ position: 'absolute', marginTop: '45px', right: '13px', cursor: 'pointer' }}
                >
                    < i onClick={() => {
                        setquantityAlignmentModel({ mappingId: data.id, quantityLine: data.quantityLine, minLimit: data.minLimit });
                        setOpenQuantityAlignmentModal({ open: true, mappingId: data.id, quantityLine: data.quantityLine, minLimit: data.minLimit });
                    }}
                        className={`mdi mdi-36px mdi-chart-line`} />
                </span>
            }
            <div style={{ display: 'block' }}>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <div className="title black-text col s8" style={{ padding: '0px', paddingLeft: '0px' }}>
                        {data.partNumber} - {data.partNumberDesc}
                    </div>
                    <div className="black-text col s8" style={{ padding: '0px', paddingLeft: '0px' }}>
                        PDU: {data.pdu}
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '0px', color: "black" }}>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('mapping:qme', 'line-picking')}: ${data.qme || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('mapping:mdr', 'line-picking')}: ${data.mdr || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('mapping:class', 'line-picking')}: ${data.class || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('mapping:space', 'line-picking')}: ${data.space || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('mapping:route', 'line-picking')}: ${data.route || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('mapping:station', 'line-picking')}: ${data.station || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('mapping:street', 'line-picking')}: ${data.street || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('mapping:side', 'line-picking')}: ${data.side || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('mapping:line', 'line-picking')}: ${data.line || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('mapping:model', 'line-picking')}: ${data.model || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('mapping:box-limit', 'line-picking')}: ${data.boxLimit || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('mapping:gravitational', 'line-picking')}: ${data.gravitational || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('mapping:parts', 'line-picking')}: ${data.parts || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('mapping:code', 'line-picking')}: ${`L${leftPad(data.id + 1, 9, '0')}` || ''}`}</small>
                    </div>
                    {quantityAlignment && data.minLimit &&
                        <div className="col s4" style={{ padding: '0px' }}>
                            <small>{`${translate('mapping:minLimit', 'line-picking')}:  ${data.minLimit || ''}`}</small>
                        </div>
                    }
                    {quantityAlignment && data.quantityLine &&
                        <div className="title black-text col s12" style={{ padding: '0px' }}>
                            {`${translate('mapping:quantityAlignment', 'line-picking')}:  ${data.quantityLine || ''}`}
                        </div>
                    }
                </div>
            </div>
        </div>
    }



    return (
        <div>
            <BackButton {...props} />
            <Title icon="mdi mdi mdi-qrcode" label={translate('mapping:title', 'line-picking')} />
            <Subtitle icon="mdi mdi-clipboard-list-outline" label={!quantityAlignment ? "Lista" : "Alinhamento Quantidade"} />
            <div className="container-fluid" style={{ marginTop: '5px' }}>
                <div className="container">
                    <Collapsible
                        id="collapsible2"
                        header={translate('filter', 'physical-confirmation')}
                        body={
                            <>
                                <div id="formfilter" className="row">
                                    <div className="input-field no-padding col s11">
                                        <Input
                                            id="partNumber"
                                            name='partNumber'
                                            label={translate('mapping:partnumber', 'line-picking')}
                                            type="text"
                                            maxLength="11"
                                            value={filter?.partNumber || ''}
                                            onChange={onChange}
                                        />
                                    </div>

                                    <div className="input-field no-padding col s6">
                                        <Input
                                            id="pdu"
                                            name='pdu'
                                            label={translate('mapping:pdu', 'line-picking')}
                                            type="text"
                                            defaultValue={filter?.pdu || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="gravitational"
                                            name='gravitational'
                                            label={translate('mapping:gravitational', 'line-picking')}
                                            type="number"
                                            defaultValue={filter?.gravitational || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            id="station"
                                            name='station'
                                            label={translate('mapping:station', 'line-picking')}
                                            type="number"
                                            maxLength="3"
                                            value={filter?.station || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="createdBy"
                                            name='createdBy'
                                            label={translate('stock:form.user')}
                                            type="text"
                                            maxLength="50"
                                            value={filter?.createdBy || ''}
                                            onChange={onChange}

                                        />
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <Select
                                            id="line"
                                            label={translate('mapping:line', 'line-picking')}
                                            name="line"
                                            display="description"
                                            change={addLineFilter}
                                            multiple={true}
                                            changeAll={addLineAll}
                                            placeHolder={translate('general:choose-one-option')}
                                            disablePlaceHoderSelect={true}
                                            data={mappingsRegistration.filter(i => i.mappingRegistrationTypeId === ENUMS.eMappingRegistrationType.Line.value) ? mappingsRegistration.filter(i => i.mappingRegistrationTypeId === ENUMS.eMappingRegistrationType.Line.value).map((i) => {
                                                return { id: i.code, text: i.description };
                                            }) : []}
                                            clearAll={() => {
                                                setFilter({ line: [] });
                                            }}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Select
                                            id="side"
                                            label={translate('mapping:side', 'line-picking')}
                                            name="side"
                                            display="description"
                                            change={addSideFilter}
                                            multiple={true}
                                            changeAll={addSideAll}
                                            placeHolder={translate('general:choose-one-option')}
                                            disablePlaceHoderSelect={true}
                                            data={[{ id: "SX", text: "SX", },
                                            { id: "DX", text: "DX" }
                                            ]}
                                            clearAll={() => {
                                                setFilter({ side: [] });
                                            }}
                                        />
                                    </div>


                                    <div className="input-field no-padding col s6">
                                        <Select
                                            id="class"
                                            label={translate('mapping:class', 'line-picking')}
                                            name="class"
                                            display="description"
                                            change={addClassFilter}
                                            multiple={true}
                                            changeAll={addClassAll}
                                            placeHolder={translate('general:choose-one-option')}
                                            disablePlaceHoderSelect={true}
                                            data={mappingsRegistration.filter(i => i.mappingRegistrationTypeId === ENUMS.eMappingRegistrationType.Class.value) ? mappingsRegistration.filter(i => i.mappingRegistrationTypeId === ENUMS.eMappingRegistrationType.Class.value).map((i) => {
                                                return { id: i.code, text: i.description };
                                            }) : []}
                                            clearAll={() => {
                                                setFilter({ class: [] });
                                            }}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Select
                                            id="route"
                                            name="route"
                                            display="description"
                                            label={translate('mapping:route', 'line-picking')}
                                            change={addRouteFilter}
                                            multiple={true}
                                            changeAll={addRouteAll}
                                            placeHolder={translate('general:choose-one-option')}
                                            disablePlaceHoderSelect={true}
                                            data={arrayDrop}
                                            clearAll={() => {
                                                filter.route = [];
                                                setFilter({ ...filter });
                                            }}
                                        />

                                    </div>
                                </div>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text={translate('search', 'general')} onClick={() => onFilter()} />
                                </div>

                            </>
                        }
                    />
                    {
                        selectedItems.length > 0 &&
                        <Fab
                            buttons={[
                                { label: translate('change-location:top'), icon: <i className="mdi mdi-publish" />, color: 'darkgreen', onClick: () => { window.scrollTo(0, 0) } },
                                { label: translate('change-location:delete-selected'), icon: <i className="material-icons small sixth-text-color" >delete</i>, color: 'red', onClick: () => deleteSelectedItems(true) },
                                { label: "Imprimir Selecionados", icon: <i className={`mdi mdi-36px mdi mdi-printer`} />, onClick: () => setOpenModal({ open: true, mappingIds: selectedItems }) },
                            ]}
                        />
                    }
                    {!quantityAlignment &&
                        <Card>
                            <div className="row">
                                <i className="mdi mdi-36px mdi-file-excel" style={{ cursor: 'pointer' }} onClick={() => getDataToExport(1)}>{translate('ExportPDURegistration', 'stock')}</i>
                                <i className="mdi mdi-36px mdi-file-excel" style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => getDataToExport(2)}>{translate('ExportDesignPDURegistration', 'stock')}</i>
                                <i className="mdi mdi-36px mdi-file-excel" style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => getDataToExport(5)}>{translate('ExportMapping', 'stock')}</i>
                            </div>
                            <div className="row">
                                <i className="mdi mdi-36px mdi-file-excel" style={{ cursor: 'pointer' }} onClick={() => getDataToExport(3)}>{translate('ExportDesignWorkLocal', 'stock')}</i>
                                <i className="mdi mdi-36px mdi-file-excel" style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => getDataToExport(4)}>{translate('ExportInsertMonth', 'stock')}</i>
                            </div>
                        </Card>
                    }
                </div>
                {mappings.length > 0 && !quantityAlignment &&
                    <div className="container" >
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <b className="sixth-text-color">{translate('SelectAll', 'general')}</b>
                            <span className="title sixth-text-color" >
                                <i
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => onClickSelectAll()}
                                    className={`mdi mdi-checkbox-multiple-marked ${selectAll ? 'green' : 'gray'}-text`}
                                />
                            </span>
                        </div>
                    </div>
                }
                {quantityAlignment &&
                    <div className="input-field no-padding col s1" style={{ marginBottom: '10px', marginLeft: '10px' }}>
                        <button
                            className="btn-floating btn-Small btn-principal waves-effect waves-light"
                            type="button"
                            onClick={() => setOpenModalUpload(true)}>
                            <i className="Small material-icons">cloud_upload</i>
                        </button>
                    </div>
                }
                <InfiniteScroll
                    page={props.mappings?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    hasMore={currentPage < props.mappings?.totalPages}
                    data={mappings.map((item, index) => {
                        return renderItem(item, index)
                    })}
                />
            </div>
            <ConfirmModal
                id="confirmDelete"
                data={{ title: translate('validations:attention'), message: translate("token.confirmation-delete", "configuration") }}
                onConfirm={onConfirmDelete}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')}
            />
            <ConfirmModal
                id="confirmDeleteSelected"
                data={{ title: translate('validations:attention'), message: translate("token.confirmation-delete", "configuration") }}
                onConfirm={onConfirmDeleteSelected}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')}
            />
            <Modal
                open={openQuantityAlignmentModal.open}
                maxHeight="60%"
                id="ModalQuantityAlignment"
                closeModal={() => {
                    setOpenQuantityAlignmentModal({ open: false, mappingId: undefined, minLimit: undefined, quantityLine: undefined });
                    setquantityAlignmentModel({})
                }}
                content={`Alterar Quantidade`}
                children={
                    <div id="formQuantityAlignment">
                        {
                            openQuantityAlignmentModal.open && <>
                                <div input-field no-padding col s12>
                                    <InputUI
                                        label="Quantidade Lado Linha"
                                        id="quantityLine"
                                        name="quantityLine"
                                        type="number"
                                        required
                                        defaultValue={openQuantityAlignmentModal?.quantityLine || ''}
                                        onChange={onChangeQuantityAligment}
                                    />
                                </div>
                                <div input-field no-padding col s12>
                                    <InputUI
                                        label="Limite Minimo"
                                        id="minLimit"
                                        name="minLimit"
                                        type="number"
                                        required
                                        defaultValue={openQuantityAlignmentModal?.minLimit || ''}
                                        onChange={onChangeQuantityAligment}
                                    />
                                </div>
                            </>
                        }
                    </div>
                }
                dismissible={false}
                onConfirm={() => {
                    if (validateInputsRequired("formQuantityAlignment")) {
                        props.updateQuantityAlignment(quantityAlignmentModel, () => {
                            setOpenQuantityAlignmentModal({ open: false, mappingId: undefined, minLimit: undefined, quantityLine: undefined });
                            setquantityAlignmentModel({})
                            setRefresh(refresh + 1);
                        });
                    }
                }
                }
                onCancel={() => {
                    setquantityAlignmentModel({});
                    setOpenQuantityAlignmentModal({ open: false, mappingId: undefined, minLimit: undefined, quantityLine: undefined });

                }}
                btnCancel="Cancelar"
                btnConfirm="Confirmar"
            />
            <Modal
                open={openModal.open}
                maxHeight="40%"
                id="ModalPrintDownload"
                closeModal={() => setOpenModal({ open: false, mappingIds: undefined })}
                content={`Gerar Arquivo/Etiqueta Mapatura`}
                children={<SelectResource
                    id="resource"
                    name="resource"
                    value={props.user?.resource}
                />}
                dismissible={false}
                onConfirm={() => {
                    if (props.user.printer) {
                        props.sendLabelFileMapping(openModal.mappingIds, props.user.printer, () => {
                            setOpenModal({ open: false, mappingIds: undefined });

                        })
                    } else {
                        return showMessageToast({ html: translate('select-resource', 'validations'), classes: 'red' });
                    }
                }
                }
                onCancel={() => {
                    downloadFileMapping(openModal.mappingIds)
                }}
                btnCancel="Baixar"
                btnConfirm="Enviar Impressora"
            />
            <ModalUploadQuantityMassive
                open={openModalUpload}
                id="ModalUploadQuantityMassive"
                onCancel={() => setOpenModalUpload(false)}
                onClose={() => setOpenModalUpload(false)}
                onConfirm={() => setOpenModalUpload(false)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div >
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        mappings: state.linePickingReducer.mappings
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLastReceiptStorageByPartnumbers: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getLastReceiptStorageByPartnumbers(filter, callback));
        },
        getMappingPaged: (filter, bind, callback) => {
            dispatch(LinePickingService.getMappingPaged(filter, bind, callback));
        },
        setMapping: (item) => {
            dispatch(actionLinePicking.setMapping(item));
        },
        deleteMapping: (id, callback) => {
            dispatch(LinePickingService.deleteMapping(id, callback));
        },
        deleteSelected: (selectedIds, callback) => {
            dispatch(LinePickingService.deleteSelectedMappings(selectedIds, callback));
        },
        sendLabelFileMapping: (selectedIds, printer, callback) => {
            dispatch(LinePickingService.sendLabelFileMapping(selectedIds, printer, callback));
        },
        downloadFileMapping: (selectedIds, callback) => {
            dispatch(LinePickingService.downloadFileMapping(selectedIds, callback));
        },
        getVehiclesAll: (filter, callback) => {
            dispatch(StockService.getVehiclesAll(filter, callback));
        },
        getAreasAll: (filter, callback) => {
            dispatch(StockService.getAreasAll(filter, callback));
        },
        getRoutes: (filter, callback) => {
            dispatch(RoutePickingService.getRouteDrop(callback));
        },
        getMappingRegistrationAll: (filter, callback) => {
            dispatch(LinePickingService.getMappingRegistrationAll(filter, callback));
        },
        updateQuantityAlignment: (quantityAlignment, callback) => {
            dispatch(LinePickingService.updateQuantityAlignment(quantityAlignment, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MappingList));
